import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useTranslation } from 'src/i18n';
import CircuitDynamicTable from '../CommissioningCircuit/CircuitDynamicTable';

// Section 6 (Secondary Field Wire Tests). The paper form prints a fixed block of blank rows;
// here it starts at four and grows, so the report only carries the circuits actually tested.
export default function PanelAuditFieldWireTests (props) {
  const { data, onChange, readOnly } = props;
  const { t } = useTranslation();

  const columns = useMemo(() => [
    { key: 'circuitBreakerNumber', label: t('panelAudit.fieldWireTests.circuitBreakerNumber'), width: '15%' },
    { key: 'controllerNumber', label: t('panelAudit.fieldWireTests.controllerNumber'), width: '18%' },
    { key: 'voltage', label: t('panelAudit.fieldWireTests.voltage'), type: 'number', width: '12%' },
    { key: 'current', label: t('panelAudit.fieldWireTests.current'), type: 'number', width: '12%' },
    { key: 'comments', label: t('panelAudit.fieldWireTests.comments') },
  ], [t]);

  return (
    <CircuitDynamicTable
      readOnly={readOnly}
      title={t('panelAudit.fieldWireTests.title')}
      typeLegend={t('panelAudit.fieldWireTests.legend')}
      columns={columns}
      data={data?.getIn(['fieldWireTests', 'items'])}
      extrasKey={['fieldWireTests', 'items']}
      onChange={onChange}
      numbered
      deletable
      minRows={4}
    />
  );
}

PanelAuditFieldWireTests.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

PanelAuditFieldWireTests.defaultProps = {
  readOnly: false,
};
